// OrganizationManager.tsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
    Box,
    Text,
    Title,
    Space,
    Table,
    Flex,
    Button
} from '@mantine/core';
import { Organization } from '../../../models/Organization';
import { getToken } from '../../../auth/service/authService';
import { useNavigate } from 'react-router-dom';
import CreateOrganization from './CreateOrganization';
import {BackendUrl} from "../../../util/config"; // import your new component

const OrganizationManager: React.FC = () => {
    const navigate = useNavigate();
    const [organizations, setOrganizations] = useState<Organization[]>([]);
    const token: string | null = getToken();

    useEffect(() => {
        fetchOrganizations();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchOrganizations = async () => {
        try {
            if (!token) {
                console.error('No token found.');
                return;
            }
            const res = await axios.get<Organization[]>(
                BackendUrl + '/organizations',
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setOrganizations(res.data);
        } catch (error) {
            console.error('Error fetching organizations:', error);
        }
    };

    return (
        <Box>
            <Flex align="center" justify="space-between">
                <Title order={2}>Betriebe</Title>

                {/* Use CreateOrganization and pass a callback to refetch on success */}
                <CreateOrganization onCreateSuccess={fetchOrganizations} />
            </Flex>

            <Space h="md" />

            <Table>
                <Table.Thead>
                    <Table.Tr>
                        <Table.Th />
                        <Table.Th>Name</Table.Th>
                        <Table.Th>Addresse</Table.Th>
                        <Table.Th>Mitglieder</Table.Th>

                    </Table.Tr>
                </Table.Thead>

                <Table.Tbody>
                    {organizations.map((org) => (
                        <Table.Tr key={org.id}>
                            <Table.Td>
                                <Button
                                    variant="filled"
                                    onClick={() => navigate(`/organizations/${org.id}`)}
                                >
                                    Bearbeiten
                                </Button>
                            </Table.Td>
                            <Table.Td>{org.name}</Table.Td>
                            <Table.Td>
                                {org.street}, {org.city}, {org.state} {org.zip}, {org.country}
                            </Table.Td>
                            <Table.Td>
                                {org.memberships && <Text>{org.memberships.length}</Text>}
                            </Table.Td>

                        </Table.Tr>
                    ))}
                </Table.Tbody>
            </Table>
        </Box>
    );
};

export default OrganizationManager;
